import produce from 'immer';
import { ActionStatus } from 'thunkless';

import { AnalyticsTypes } from '../actions/analytics';
import { AppAction } from '../actions';
import { InboxUser} from 'app/javascript/redux/app/reducers/inbox';

export interface AnalyticsState {
  demoUsersFetchStatus: ActionStatus;
  demoUsers: Record<string, InboxUser>;
}

export const initialState: AnalyticsState = {
  demoUsersFetchStatus: null,
  demoUsers: null,
};

export const reducer = produce((state: AnalyticsState, action: AppAction) => {
  switch (action.type) {
    case AnalyticsTypes.FETCH_DEMO_USERS_REQUEST:
      state.demoUsersFetchStatus = ActionStatus.BUSY;
      break;
    case AnalyticsTypes.FETCH_DEMO_USERS_SUCCESS:
      const { data } = action.payload;
      state.demoUsers = data.users.reduce((acc, user) => {
        acc[user.id] = user;
        return acc;
      }, {});
      state.demoUsersFetchStatus = ActionStatus.SUCCESS;
      break;
    case AnalyticsTypes.FETCH_DEMO_USERS_FAILURE:
      state.demoUsersFetchStatus = ActionStatus.FAILURE;
      break;
  }
}, initialState);
